document
  .getElementById('menu-toggle-open')
  .addEventListener('click', function () {
    document.getElementsByTagName('HTML')[0].classList.add('menu-open')
  })

document
  .querySelectorAll('.menu-toggle-close, #menu-background')
  .forEach((element) => {
    element.addEventListener('click', function () {
      document.getElementsByTagName('HTML')[0].classList.remove('menu-open')
    })
  })

document
  .querySelectorAll('#menu button[data-open-level]')
  .forEach(function (button) {
    button.addEventListener('click', function () {
      const clickedHandle = button.getAttribute('data-open-level')
      const drawerToOpen = document.querySelector(
        `#menu .sub-levels .level[data-level="${clickedHandle}"]`
      )

      document
        .querySelectorAll(`#menu .sub-levels .level[data-level]`)
        .forEach(function (drawer) {
          drawer.classList.remove('open')
        })

      drawerToOpen.classList.add('open')
    })
  })

document
  .querySelectorAll('#menu header.level-header button.back')
  .forEach(function (button) {
    button.addEventListener('click', function () {
      document
        .querySelectorAll(`#menu .sub-levels .level[data-level]`)
        .forEach(function (drawer) {
          drawer.classList.remove('open')
        })
    })
  })

document
  .querySelector('header#header nav a[href="/collections/all"]')
  .addEventListener('click', function (event) {
    event.preventDefault()
    document.getElementById('menu-toggle-open').click()
  })
